const cities = [
  { name: "Tallahassee", zips: "32301" },
  { name: "Quincy", zips: "32351" },
  { name: "Monticello", zips: "32344" },
  { name: "Crawfordville", zips: "32327" },
  { name: "Midway", zips: "32343" },
  { name: "Havana", zips: "32333" },
  { name: "Thomasville, GA", zips: "31792" },
  { name: "Valdosta, GA", zips: "31601" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function TallahasseeLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Tallahassee &amp; North Florida
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Tallahassee, Quincy, Monticello, or anywhere across the Big Bend region and into South Georgia, Fast Passport Center makes expedited passport processing simple — no drive to Atlanta, no agency lines, no guessing.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Service Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col xl:flex-row gap-6">
                {/* Info side */}
                <div className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Tallahassee</p>
                  <p className="text-white/60 text-xs mt-0.5">106 E College Ave, Tallahassee, FL 32301</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Local office — we serve all of Leon, Jefferson, Wakulla, and Gadsden counties
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout the Big Bend region</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Tallahassee office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map side */}
                <div className="xl:w-[340px] flex-shrink-0">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=106+E+College+Ave,+Tallahassee,+FL+32301&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Tallahassee Office Location"
                      aria-label="Google Map showing Fast Passport Center Tallahassee office at 106 E College Ave"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    106 E College Ave, Tallahassee, FL 32301
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere across the Big Bend region of North Florida and into South Georgia — start online, ship overnight, and we handle the rest. No need to drive to Atlanta.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Pensacola", href: "/pensacola" },
                    { name: "Panama City", href: "/panama-city" },
                    { name: "Quincy", href: "/quincy" },
                    { name: "Jacksonville", href: "/jacksonville" },
                    { name: "Valdosta", href: "/states/florida" },
                    { name: "Thomasville", href: "/states/florida" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}